import { matchPath } from 'react-router-dom';

import { MAIN_PATH } from '../../routes/consts';
import { EProcessENV } from '../enum';

export const isNoQrBypassEnv = () => process.env.APP_ENV === EProcessENV.PRE;

export const shouldShowPinAndPhoneOnNoQr = (pathname: string) => pathname.endsWith('/no-qr') && isNoQrBypassEnv();

export const isQrRedirectionRoute = (pathname: string) => {
  if (shouldShowPinAndPhoneOnNoQr(pathname)) {
    return false;
  }

  if (pathname.endsWith('/no-qr')) {
    return true;
  }

  return !!matchPath({ path: MAIN_PATH, end: true }, pathname);
};
